// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination__container___Ra_Jo","page":"Pagination__page___3irHv","disabled":"Pagination__disabled___21Ptu"};